import { useEffect, useState } from 'react';
const pxToInt = px => parseInt(px.slice(0, px.length - 2), 10);

/**
 * Allows a textarea to grow or shrink automatically while its content is changed
 * @param ref Target (textarea) element ref
 * @param defaultHeight Initial textarea height
 * @returns height, updateHeight
 * @see Textarea
 * @example
 * import { useAutoHeight, useForwardedRef } from '@adsk/alloy-react-helpers';
 * ...
 * const textareaRef = useForwardedRef(ref);
 * const [height, updateHeight] = useAutoHeight(textareaRef);
 */
export default function useAutoHeight(ref) {
  let defaultHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const [height, setHeight] = useState(defaultHeight);
  const updateHeight = () => {
    const element = ref.current;
    if (element instanceof HTMLTextAreaElement) {
      const style = window.getComputedStyle(element);
      element.style.height = '0';

      // Measure scrollHeight while textarea height is temporarily set to zero
      const nextHeight = element.scrollHeight + pxToInt(style.borderTopWidth) + pxToInt(style.borderBottomWidth);
      element.style.height = "".concat(nextHeight, "px");
      setHeight(nextHeight);
    }
  };
  useEffect(() => {
    const element = ref.current;
    if (element instanceof HTMLTextAreaElement) {
      if (element.selectionEnd === element.value.length) {
        element.scrollTop = element.scrollHeight;
      }
    }
  }, [height, ref]);
  return [height, updateHeight];
}
//# sourceMappingURL=useAutoHeight.js.map